import moment from 'moment'

export const epochToDisplay = (epoch: number): string => {
  return moment(epoch).format('YYYY/MM/DD HH:mm')
}

export const dateToDisplay = (date: Date | null): string => {
  if (date === null) {
    return '-'
  }
  return moment(date).format('YYYY/MM/DD HH:mm')
}
